import { useMutation, useQueryClient } from "@tanstack/react-query";
import { openReferral } from "api/user";
import getFirebaseIdToken from "utils/getFirebaseIdToken";
import useShowSnackBar from "hooks/snackBar/useShowSnackBar";
import { useTranslation } from "react-i18next";

interface Payload {
  description: string;
}

const useChangeUser = () => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const showSnackBar = useShowSnackBar();

  return useMutation<void, Error, Payload>(
    ["request-referral"],
    async ({ description }) => {
      const token = await getFirebaseIdToken();

      if (token && description) {
        return openReferral(token, { description });
      }

      if (description == null)
        return Promise.reject(new Error("Invalid description"));
      return Promise.reject(new Error("Invalid Firebase ID Token"));
    },
    {
      onSuccess: () => {
        showSnackBar({
          title: t("notification.referralRequested.title"),
          text: t("notification.referralRequested.text"),
        });
        return queryClient.invalidateQueries({ queryKey: ["user"] });
      },
      onError: (e) => {
        showSnackBar({
          title: t("notification.commonError.title"),
          text: e.message,
          variant: "error",
        });
      },
    },
  );
};

export default useChangeUser;
